import { css } from "lit";

/**
 * Der Rhythmus einer Seite, die aus BLÖCKEN besteht — an einer Stelle.
 *
 * Startseite, Bezirks- und Stadtteilprofil sind alle so gebaut: eine Folge von
 * `<section>`, getrennt durch Weißraum statt durch Linien. Der Abstand dazwischen
 * stand vorher dreimal im Code, die Ausnahme für die erste Section nur einmal —
 * und genau die fehlte den beiden Profilseiten.
 *
 * DIE ERSTE SECTION BEKOMMT WENIGER. Der volle Blockabstand (6rem) trennt
 * BLÖCKE voneinander; unter einer Haarlinie — dem Seitenkopf — wirkt er wie ein
 * Loch. Dort steht kein zweiter Block über der Section, sondern die Kopfzeile
 * der Seite, und die gehört zum Inhalt.
 *
 * Das ist dieselbe Lehre wie beim Abstand Menü ↔ Seiteninhalt und beim Raster
 * der Gremien-Kacheln: Abstände gehören an die Stelle, die den Rhythmus kennt —
 * nicht an das Bauteil, das gerade zufällig zuerst kommt.
 */
export const blockSeitenStyles = css`
  /*
   * DIE SCHIENE — derselbe Satzspiegel wie die Bloecke.
   *
   * Block-Bauteile bringen ihn selbst mit — blockStyles setzt ihn am :host.
   * Markup, das direkt auf der Seite steht — eine Kopfzeile etwa —, hat ihn
   * nicht und steht dann um eine Rinne weiter links als alles darunter. Genau
   * so ist der Kopf der Bezirksvertretungs-Seite aus der Flucht geraten.
   */
  .schiene {
    max-width: var(--portal-content-width);
    margin: 0 auto;
    /*
     * NUR waagerecht. Die Kurzform padding: 0 <gutter> würde das padding-top
     * der Section-Regel darunter mit ausnullen — und die Klasse schlägt den
     * Typ-Selektor. Genau so war der Blockabstand auf jeder Seite still weg,
     * deren Sections selbst die Schiene tragen (Quellen, Ausschüsse, Gremium,
     * Rat, Wahlen, Parteien, Sitzungen, Sitemap, Impressum); sichtbar blieb er
     * nur bei der ersten Section, weil section:first-of-type spezifischer ist
     * als die Klasse.
     */
    padding-inline: var(--portal-gutter);
  }

  section {
    padding-top: var(--portal-block-gap);
    /*
     * Sprungziele landen mit derselben Luft wie der Seitenanfang. Das Framework
     * setzt hier fest verdrahtete 20 px; derselbe Token statt einer zweiten
     * Zahl hält Anfang und Sprung in einer Sprache.
     */
    --sprung-basis: calc(
      var(--pd-site-header-height, 90px) + var(--portal-abschnitte-hoehe, 0px) +
        var(--portal-seitenabstand)
    );
    /*
     * ABZÜGLICH DER EIGENEN POLSTERUNG. scroll-margin-top richtet die OBERKANTE
     * des Kastens aus — und die liegt hier einen Blockabstand über dem Text.
     * Ohne den Abzug hält der Sprung genau eine Blockhöhe zu früh: oben bleibt
     * der Fuß des vorigen Blocks stehen, die Überschrift rutscht ins untere
     * Drittel. Der Abzug schiebt nur die leere Polsterung hinter die Leisten,
     * am Bild der Seite ändert sich nichts.
     */
    scroll-margin-top: calc(var(--sprung-basis) - var(--portal-block-gap));
  }

  section:first-of-type {
    padding-top: var(--portal-space-8);
    /* Dieselbe Rechnung mit der kleineren Polsterung der ersten Section. */
    scroll-margin-top: calc(var(--sprung-basis) - var(--portal-space-8));
  }
`;
